// lib/http/server.js
import { createBaseService, applyDefaultParams } from './common'

import { LRUCache } from 'lru-cache';

const ssrCache = new LRUCache({
    max: 100,             // 最大缓存条目数
    ttl: 1000 * 60,    // 缓存60秒
});

const generateCacheKey = (api, params = {}) => {
    const sortedParams = Object.keys(params).sort().reduce((acc, key) => {
        acc[key] = params[key];
        return acc;
    }, {});
    return `${api}_${JSON.stringify(sortedParams)}`;
};

const successCallback = (res) => {
    if (res.result.success) {
        return res.result.data
    }

    let msg = res.result.msg || '请求失败'
    let code = res.result.code || 500

    return Promise.reject({
        error: true,
        data: null,
        code,
        msg,
    })

}


export const createServerService = () => {
    const instance = createBaseService('server')

    instance.interceptors.request.use(config => {
        config = applyDefaultParams(config)


        config.params.api = config.api;


        config.params.data = JSON.stringify(config.params.data || {})

        // console.log('完整请求URL:',
        //     config.baseURL + config.url,
        //     '参数:',
        //     config.params
        // )
        return config
    })

    instance.interceptors.response.use(
        response => {
            return successCallback(response.data);
        },
        error => {
            console.log("🚀 ~ createServerService ~ error:", error)
            return Promise.reject(error)
        }
    )

    return {
        get: (api, params = {}, config) => {
            const startTime = Date.now(); // 记录总开始时间

            const cacheKey = generateCacheKey(api, params);
            const cachedData = ssrCache.get(cacheKey);
            if (cachedData) {
                const duration = Date.now() - startTime;
                console.log(`服务端接口 ${api} 缓存命中，耗时 ${duration}ms`);
                return Promise.resolve(cachedData);
            }
            return instance.get('', { ...config, params, api })
                .then(response => {
                    ssrCache.set(cacheKey, response);
                    const totalDuration = Date.now() - startTime;
                    console.log(`服务端接口 ${api} 总耗时 ${totalDuration}ms`);
                    return response;
                });
        },
        post: (api, data, config) =>
            instance.post('', data, { ...config, api })
    }
}